module.exports = __webpack_public_path__ + "static/img/cont3007.587c2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3007.jpg
// module id = NHuw
// module chunks = 0